export default {
  'billing.checkout.status.loading': 'Consultando estado del pago...',
  'billing.checkout.status.confirming': 'Estamos confirmando tu pago...',
  'billing.checkout.status.cancelPending': 'Pago no completado',
  'billing.checkout.status.cancelPendingTimeout':
    'No completaste el pago. Si se realizó un cargo, lo verás reflejado en tu cuenta.',
  'billing.checkout.status.completed': 'Pago confirmado',
  'billing.checkout.status.failed': 'No pudimos confirmar el pago',
  'billing.checkout.status.cancelled': 'Pago cancelado',
  'billing.checkout.status.expired': 'La sesión de pago expiró',
  'billing.checkout.status.pendingTimeout':
    'Seguimos confirmando tu pago. Puedes volver más tarde.',
  'billing.checkout.status.unknown': 'Estado de pago no disponible',
  'billing.checkout.status.missingSession': 'No se encontró la sesión de pago.',

  'billing.checkout.pageSubtitle': 'Resultado de tu transacción de pago',
  'billing.checkout.cardTitle': 'Estado del pago',
  'billing.checkout.error.generic':
    'No fue posible obtener el estado del pago. Puedes reintentar o volver atrás.',

  'billing.checkout.section.financial': 'Resumen financiero',
  'billing.checkout.section.payment': 'Pago',
  'billing.checkout.section.billing': 'Facturación',
  'billing.checkout.section.business': 'Resultado',

  'billing.checkout.fields.subtotal': 'Subtotal',
  'billing.checkout.fields.tax': 'Impuestos',
  'billing.checkout.fields.taxCalculatedAtCheckout': 'Se calcula en el checkout',
  'billing.checkout.fields.total': 'Total',
  'billing.checkout.fields.currency': 'Moneda',
  'billing.checkout.fields.provider': 'Proveedor',
  'billing.checkout.fields.paymentMethod': 'Método de pago',
  'billing.checkout.fields.completedAt': 'Fecha de pago',
  'billing.checkout.fields.reference': 'Referencia',
  'billing.checkout.fields.failureReason': 'Motivo del fallo',
  'billing.checkout.fields.billingName': 'Razón social / nombre',
  'billing.checkout.fields.customerEmail': 'Email',
  'billing.checkout.fields.billingTaxId': 'Tax ID / RUC',
  'billing.checkout.fields.billingCountry': 'País',
  'billing.checkout.fields.concept': 'Concepto',

  'billing.checkout.paymentMethod.endingIn': '{brand} terminada en {last4}',

  'billing.checkout.purpose.aiCreditRecharge': 'Créditos agregados: {amount}',

  'billing.checkout.provider.stripe': 'Stripe',
  'billing.checkout.provider.bank-transfer': 'Transferencia bancaria',
  'billing.checkout.provider.manual': 'Manual',

  'billing.checkout.action.back': 'Volver a AI Billing',
  'billing.checkout.action.retry': 'Reintentar pago',
};
